// CommentatorDelete.tsx
import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete, useNavigation } from "@refinedev/core";
import { errorNotification, successNotification } from "../../helpers";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

type CommentatorDeleteProps = {
  id: number;
  name: string;
  type?: "page" | "table";
};

export const CommentatorDelete: FC<CommentatorDeleteProps> = ({
  id,
  name,
  type = "table",
}) => {
  const { modalProps, show, close } = useModal();
  const { mutate: deleteMutate } = useDelete();
  const { push } = useNavigation();

  const handleDelete = () => {
    deleteMutate({
      dataProviderName: "commentatorsDataProvider",
      resource: "commentators",
      id: id,
      ...successNotification({
        successData: {
          message: `Комментатор «${name}» успешно удален`,
          type: "success",
        },
        callback: () => {
          close();
          push("/commentators");
        },
      }),
      ...errorNotification({}),
    });
  };

  return (
    <>
      {type === "table" ? (
        <Button
          size={"small"}
          danger
          onClick={show}
          block
          icon={<DeleteOutlined />}
        >
          Удалить
        </Button>
      ) : (
        <Button danger onClick={show} block icon={<DeleteOutlined />}>
          Удалить комментатора
        </Button>
      )}

      <Modal
        okText={"Удалить"}
        cancelText={"Отмена"}
        onOk={handleDelete}
        title={"Подтверждение удаления"}
        onCancel={close}
        okType="danger"
        {...modalProps}
      >
        Вы уверены, что хотите удалить комментатора «{name}»?
      </Modal>
    </>
  );
};
